var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg" }, [
    _c(
      "div",
      { staticClass: "btn-back" },
      [
        _c(
          "el-button",
          {
            staticStyle: { width: "200px" },
            attrs: { icon: "el-icon-caret-left", round: "", type: "danger" },
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [_vm._v(" 返回 ")]
        ),
        _c(
          "el-button",
          {
            staticStyle: { width: "200px" },
            attrs: { icon: "el-icon-s-home", round: "", type: "warning" },
            on: {
              click: function ($event) {
                return _vm.$router.push({ name: "welcome" })
              },
            },
          },
          [_vm._v(" 首页 ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }